import React, { useCallback } from 'react'
import { ToolBar, Button } from '@sencha/ext-modern'
import _ from 'lodash'

import { reconfigButton } from 'tyan/public/utility'
import SearchField from './SearchField'
import { useInstData } from 'tyan/public/hooks'

const PhoneToolbar = props => {
	const {
		calcThat,
		config, searchValue, handleSearchFieldChange, handleExport,
		pageNum, minPage, maxPage, onPageSelected,
		handleToolbarButton
	} = props

	const {
		me: { state: { showSearch = false, } },
		setState
	} = useInstData(props)

	const toggleSearch = useCallback(() => { setState(prev => ({ showSearch: !prev.showSearch })) }, [])

	return <ToolBar docked="top" layout={{ type: 'hbox', pack: 'space-between' }}>
		{!showSearch && (config.buttons || []).map((o, i) => {
			const { icon, text, disabled, ui = '', align = 'left', cdt } = reconfigButton(o)
			return (!cdt || calcThat(cdt)) && <Button margin={0} key={i} iconCls={icon && `x-fa fa-${icon}`} text={text} align={align} ui={ui}
				handler={() => handleToolbarButton(o)}
				disabled={calcThat(disabled)}
			/> || null
		})}
		{/* {!showSearch && config.export && <Button iconCls={`x-fa fa-download`} text="导出" ui="" handler={handleExport} />} */}
		{!showSearch && <Button iconCls="x-fa fa-angle-double-left" text="" handler={() => onPageSelected(pageNum - 1)} disabled={pageNum <= minPage} />}
		{!showSearch && <Button iconAlign="right" iconCls="x-fa fa-angle-double-right" text="" handler={() => onPageSelected(pageNum + 1)} disabled={pageNum >= maxPage} />}
		{showSearch && <SearchField value={searchValue} placeholder={`搜索 ...`} onChange={handleSearchFieldChange} width="50%" />}
		<Button iconAlign="right" iconCls={showSearch ? "x-fa fa-times" : "x-fa fa-search"} text="" handler={toggleSearch} />
	</ToolBar>
}

export default PhoneToolbar